import { AnalyticsEvent } from "./enums/analytics-event.enum";
import { IAnalyticsBindEventData } from "./interfaces/analytics-data.interface";

export function getEventName(event: AnalyticsEvent, params?: Record<string, any>, bindEventsList?: IAnalyticsBindEventData[], prefix?: string) {
  let eventName: string = event;

  if (bindEventsList) {
    const customEventName = bindEventsList.find(item => item.event == event)?.value;
    eventName = customEventName || eventName;
  }

  eventName = prefix ? prefix + "_" + eventName : eventName;

  if (event == AnalyticsEvent.REACH_QUESTION && params?.question) {
    eventName = `${eventName}_${params.question}`;
  }

  if (event == AnalyticsEvent.PICK_ANSWER && params?.answerIds) {
    eventName = `${eventName}_${params.questionName}_${(params.answerIds as Array<string | number>).join(",")}`;
  }

  return eventName;
}